import { useState } from "react"
import getCheckPolicy from "./getCheckPolicy"
import putCheckPolicy from "./putCheckPolicy"
import putPdpa from './putPdpa'
const usePolicy = () => {

    const [policy, setPolicy] = useState({ statusCode: "999", status: 999, data: null, msg: "" })
    const getCheckPolicyApi = async () => {
        try {
            const request = await getCheckPolicy()
            setPolicy(request)
        } catch (error) {
            setPolicy(error)
        }
    }

    const putCheckPolicyApi = async (value) => {
        try {
            const request = await putCheckPolicy(value)
            setPolicy(request)
        } catch (error) {
            console.log(error)
            setPolicy(error)
        }
    }

    const putPdpaApi = async (value) => {
        try {
            const request = await putPdpa(value)
            setPolicy(request)
        } catch (error) {
            console.log(error)
            setPolicy(error)
        }
    }

    return {
        policy,
        setPolicy,
        putPdpaApi,
        getCheckPolicyApi,
        putCheckPolicyApi
    }
}

export default usePolicy